import { render } from "./App.vue?vue&type=template&id=98b5f262"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=98b5f262&lang=scss"

import exportComponent from "/Users/Shared/PLAYLANE/buildAgent/work/73b64d940d146bd6/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__